import { z } from 'zod';

const ProductSchema = z.object({
  productId: z.number().optional(),
  alcoholTypeId: z
    .number({
      invalid_type_error: 'Please select a value.',
    })
    .nullable().optional(),
  bidderCampaignId: z.number(),
  bidderContractId: z.number(),
  catId: z.number({
    invalid_type_error: 'Please select a value.',
  }),
  descr: z.string().nonempty(),
  minAge: z.number(),
  name: z.string().nonempty(),
  prefixLen: z.number({
    invalid_type_error: 'Please select a value.',
  }),
  upcCodes: z.string().optional(),
  urlImage: z.string({
    invalid_type_error: 'Please upload an image.',
  }).nonempty(),
  venturaAdvertiserId: z.number(),
});

export default ProductSchema;
